import YFormParagraph from './Paragraph';

export { YFormParagraph };
export default YFormParagraph;
